// make header sticky
document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector("header-component#header-component");
  const headerSection = document.querySelector("header.header-section");

  if (!header || !headerSection) return;

  const headerHeight = header.offsetHeight;

  // Show initially
  headerSection.classList.add("initial-header");

  window.addEventListener("scroll", function () {

    if (window.scrollY >= headerHeight) {
      headerSection.classList.add("sticky-header");
    } else {
      headerSection.classList.remove("sticky-header");
    }

  });
});

// Anchor Links
jQuery(document).ready(function ($) {

  $(document).on('click', '.menu-drawer__menu-item[href*="#"]', function (e) {

    const href = $(this).attr('href');
    const targetId = href.substring(href.indexOf('#'));

    if ($(targetId).length) {

      e.preventDefault();

      $('.menu-drawer__close-button').trigger('click');

      setTimeout(function () {

        const offset = 90;
        const targetPosition = $(targetId).offset().top - offset;

        $('html, body').animate({
          scrollTop: targetPosition
        }, 600);

      }, 300);

    }

  });

});


 AOS.init({
  duration: 1200,
  once: false,   // 🔥 important (re-trigger on scroll up/down)
  mirror: true   // optional (scroll up pe bhi animate ho)
});

  // Scroll movement effect
  
document.addEventListener("DOMContentLoaded", function () {

  const section = document.querySelector(".not-just-game .right-col");

  const items = document.querySelectorAll(
    ".top-right, .bottom-left, .bottom-right, .center-left, .center-card"
  );

  if (!section) return;

  const observer = new IntersectionObserver(
    (entries) => {

      entries.forEach((entry) => {

        if (entry.isIntersecting) {

          items.forEach((item) => {
            item.classList.add("active-card");
          });

        }

      });

    },
    {
      threshold: 0.3 // adjust trigger point
    }
  );

  observer.observe(section);

});

// accordion script start

const accordions = document.querySelectorAll(".accordion");

// Open first accordion by default
if (accordions.length > 0) {
  const firstAccordion = accordions[0];
  const firstBody = firstAccordion.querySelector(".accordion-item-body");

  firstAccordion.classList.add("active");
  firstBody.style.maxHeight = firstBody.scrollHeight + "px";
}

accordions.forEach((accordion) => {
  accordion.addEventListener("click", () => {
    const accordionItemBody =
      accordion.querySelector(".accordion-item-body");

    const isActive = accordion.classList.contains("active");

    // Close all accordions
    accordions.forEach((item) => {
      item.classList.remove("active");

      const body = item.querySelector(".accordion-item-body");
      body.style.maxHeight = 0;
    });

    // Open clicked accordion only if it was closed
    if (!isActive) {
      accordion.classList.add("active");
      accordionItemBody.style.maxHeight =
        accordionItemBody.scrollHeight + "px";
    }
  });
});


jQuery(document).ready(function ($) {

  const owl = $('.cards-slider').owlCarousel({
    loop: true,
    margin: 10,
    nav: false,
    center: true,
    dots: false,
    smartSpeed: 800,
    responsive: {
      0: {
        margin: 5,
        items: 1.2,
      },
      540: {
        margin: 10,
        items: 1.5,
      },
      768: {
        margin: 10,
        items: 1.5,
      },
      1037: {
        margin: 20,
        items: 1.5,
      },
      1337: {
        margin: 25,
        items: 1.5,
      },
      1700: {
        margin: 30,
        items: 2,
      },
    }
  });

  $('.every-card-button-next').on('click', function () {
    owl.trigger('next.owl.carousel');
  });

  $('.every-card-button-prev').on('click', function () {
    owl.trigger('prev.owl.carousel');
  });


});


/* INIT CAROUSEL AFTER MARGIN */
const boxes_slider = $('.icon-boxes-slider');

boxes_slider.owlCarousel({
  loop: true,
  nav: false,
  dots: false,
  smartSpeed: 800,

  responsive: {
    0: {
      items: 1.2,
      margin: 5
    },

    540: {
      items: 2.2,
      margin: 10
    },

    768: {
      items: 3.2,
      margin: 20
    },
    1337: {
      items: 4.1,
      margin: 20
    },
    1700: {
      items: 4.2,
      margin: 30
    }
  }
});

/* REFRESH */
boxes_slider.trigger('refresh.owl.carousel');




if (document.querySelector('.shopify-policy__container')) {
  document.body.classList.add('policy-page');
}